import {Button, Space} from "antd";
import {CheckCircleOutlined, CloseCircleOutlined, DeleteOutlined} from "@ant-design/icons";
import React, {useState} from "react";
import {DeleteParams, wrapResponse} from "../../types/utils/Constants";
import {MutationActionCreatorResult} from "@reduxjs/toolkit/dist/query/core/buildInitiate";

type DeleteButtonProps = {
    id?: number,
    accountId?: number,
    deleteFunc: (params: DeleteParams) => MutationActionCreatorResult<any>,
    isLoading: boolean,
    hidden?: boolean,
    size?: "small" | "middle" | "large",
    hasConfirmation?: boolean
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
                                                       id,
                                                       accountId,
                                                       deleteFunc,
                                                       isLoading,
                                                       hidden = false,
                                                       size = "middle",
                                                       hasConfirmation = true
                                                   }) => {

    const confirm = () => {
        setButtons([
            <Button type={"text"} key={'close'} size={size} onClick={e => {
                e.stopPropagation()
                setButtons([deleteButton])
            }}
                    icon={<CloseCircleOutlined/>}/>,
            <Button type='primary' key={'delete'} size={size} loading={isLoading}
                    onClick={e => {
                        e.stopPropagation();
                        callForDelete().then(r => r)
                    }} icon={<CheckCircleOutlined/>}/>
        ])
    }

    const deleteButton = <Button size={size} type='primary' key={'confirm'} danger onClick={e => {
        e.stopPropagation()
        hasConfirmation ? confirm() : callForDelete()
    }} icon={<DeleteOutlined/>}/>

    const [buttons, setButtons] = useState([deleteButton])


    if (hidden) return <></>


    const callForDelete = async () => {
        await wrapResponse(deleteFunc({id, accountId}).unwrap())
    }


    return (<Space>{buttons}</Space>)
}

export default DeleteButton